import LayoutPages from "@/layout/Layout2";

export default [
  {
    path: "/exam",
    component: LayoutPages,
    children: [
      {
        path: "questions/list",
        component: () => import("@/views/exam/ListQuestions"),
      },
      {
        path: "questions/add",
        component: () => import("@/views/exam/AddQuestion"),
      },
    ],
  },
];
